import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiArrowRight } from "react-icons/hi";
import "./index.css";
import PropertyImage, { formatPrice } from "./PropertyImage";
import { localized } from "../../api/client";

const SIGN = { USD: "$", EUR: "€", TRY: "₺", AED: "AED " };

const FROM = { ru: "от ", en: "from " };

export const priceLabel = (p, lang) =>
  p.price == null
    ? null
    : `${p.price_from ? FROM[lang === "en" ? "en" : "ru"] : ""}${SIGN[p.currency] || "$"}${formatPrice(p.price, lang)}`;

// Города вводятся в админке по-русски; для английской версии подменяем известные
const CITY_EN = { Дубай: "Dubai", Стамбул: "Istanbul", Анталья: "Antalya", Аланья: "Alanya", "Абу-Даби": "Abu Dhabi", "Рас-эль-Хайма": "Ras Al Khaimah", Шарджа: "Sharjah" };

export const cityLabel = (p, t, lang) => {
  const city = p.city || (p.country === "uae" ? t("site.catalog.dubai") : t("site.catalog.istanbul"));
  return lang === "en" ? CITY_EN[city] || city : city;
};

export const placeLabel = (p, t, lang) => [p.district, cityLabel(p, t, lang)].filter(Boolean).join(", ");

export const statusLabel = (p, lang) => (lang === "en" && p.status_en ? p.status_en : p.status);

export const areaLabel = (p, t, lang) =>
  p.area == null ? null : `${Number(p.area).toLocaleString(lang === "en" ? "en-US" : "ru-RU")} ${t("properties.sqm")}`;

function PropertyCard({ property: p, wide = false }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const title = localized(lang, p.title, p.title_en);
  const price = priceLabel(p, lang) || t("site.catalog.onRequest");
  const status = statusLabel(p, lang);
  const meta = [
    p.rooms,
    areaLabel(p, t, lang),
    p.bedrooms != null && !p.rooms && `${t("properties.bedrooms")}: ${p.bedrooms}`,
  ].filter(Boolean);

  return (
    <Link to={`/properties/${p.id}`} className={`pcard ${wide ? "pcard--wide" : ""}`}>
      <div className="pcard__media">
        <PropertyImage src={p.images?.[0]} alt={title} />
        <div className="pcard__chips">
          <span className="chip chip--light">{p.deal_type === "rent" ? t("site.catalog.rentBadge") : t("site.catalog.saleBadge")}</span>
          {status && <span className="chip">{status}</span>}
          {p.videos?.length > 0 && <span className="chip">▶ {t("site.property.video")}</span>}
        </div>
      </div>
      <div className="pcard__body">
        <span className="pcard__place">{placeLabel(p, t, lang)}</span>
        <h3 className="pcard__title">{title}</h3>
        {meta.length > 0 && (
          <div className="pcard__meta">
            {meta.map((m) => (
              <span key={m}>{m}</span>
            ))}
          </div>
        )}
        {wide && p.description && <p className="pcard__desc">{localized(lang, p.description, p.description_en)}</p>}
        {wide ? (
          <div className="pcard__foot">
            {price && (
              <span className="pcard__price">
                {price}
                {p.deal_type === "rent" && p.price != null && <small> {t("site.catalog.perMonth")}</small>}
              </span>
            )}
            <span className="btn-pill btn-pill--small btn-pill--ghost">
              {t("site.catalog.view")} <HiArrowRight />
            </span>
          </div>
        ) : (
          price && (
            <div className="pcard__price">
              {price}
              {p.deal_type === "rent" && p.price != null && <small> {t("site.catalog.perMonth")}</small>}
            </div>
          )
        )}
      </div>
    </Link>
  );
}

export default PropertyCard;
